<div
	class="overflow-hidden h-full grid-cols-1 grid-rows-[min-content_min-content_1fr]"
>
	<header class="page-header">
		<div class="flex">
			<h2>Document Templates</h2>
			<div class="flex flex-col justify-end ml-3 relative">
				<app-button
					btn="primary"
					[icon]="ICON.ADD"
					intercomAttr="add-new-document-btn"
					(click)="toggleDropdown()"
					(clickOutside)="hideDropdown()"
					id="documents-add"
					>Add new</app-button
				>

				<app-dropdown-options
					[show]="showDropdownOptions"
					[itemGroups]="[{ items: dropdownOptions }]"
					(onSelect)="onDropdownAction($event)"
					xposition="left"
					marginTop="10px"
				></app-dropdown-options>
			</div>
		</div>
	</header>

	<div class="flex items-end justify-between mb-5">
		<div class="flex items-center">
			<atomic-button-group
				[options]="fileTypeTabs"
				[ngModel]="currentTab"
				(ngModelChange)="changeSelectedTab($event)"
			></atomic-button-group>
		</div>

		<div class="flex grow max-w-350">
			<app-input
				[endIcon]="searchText ? ICON.CLOSE : null"
				(endItemClick)="onEndItemClick()"
				label="Search"
				[(ngModel)]="searchText"
				placeholder="Search Document Templates"
				[startIcon]="ICON.SEARCH"
			></app-input>
		</div>
	</div>

	<app-document-tree
		#documentTree
		(addDocument)="addDocument($event)"
		(addFolder)="addFolder($event)"
		[authors]="AuthorIds$ | async"
		[canCreateFolder]="canCreateFolder.bind(this)"
		[canMoveDocument]="canMoveDocument.bind(this)"
		[canMoveDocumentToFolder]="canMoveDocumentToFolder.bind(this)"
		(copyDocument)="copyDocument($event)"
		class="overflow-x-hidden overflow-y-auto"
		(deleteDocument)="deleteDocument($event)"
		(deleteFolder)="deleteFolder($event)"
		[documents]="documents$ | async"
		(editDocument)="editDocument($event)"
		(editFolder)="editFolder($event)"
		[filter]="searchText"
		[folders]="folders$ | async"
		[matterType]="currentTab"
		[mode]="documentTreeMode"
		(moveDocument)="moveDocument($event)"
		(moveDocumentsToFolder)="moveDocumentsToFolder($event)"
		[root]="true"
		(selectedDocuments)="onSelectedDocuments($event)"
		[showHeaders]="true"
		[showTypeTags]="true"
		[showVersions]="false"
	/>
</div>
